import styled, { css } from 'styled-components';

interface IGridProps {
    menuIsOpen : boolean;
}

export const Grid = styled.div<IGridProps>`
    display: grid;
    grid-template-columns: 125px auto;

    ${props => !props.menuIsOpen && css`
        grid-template-columns: 70px auto;
    `};

    grid-template-rows: 70px auto;

    grid-template-areas: 
    'AS MH'
    'AS CT';

    height: 100vh;

`;
